export type ReturnSource = 'override' | 'inherited';

export interface ClassifiedReturn {
  source: ReturnSource;
  /** Effective value: own override if set, else provider, else baked default. */
  value: number;
}

/**
 * Classify a single payout-return key for the inherited-vs-override UI.
 * `override` when the integrator's own override sets the key; otherwise
 * `inherited` (provider value if the provider set it, else the baked default).
 */
export function classifyReturn(
  key: string,
  ownReturns: Record<string, number> | undefined,
  providerReturns: Record<string, number> | undefined,
  bakedDefault: number,
): ClassifiedReturn {
  if (ownReturns && Object.prototype.hasOwnProperty.call(ownReturns, key)) {
    return { source: 'override', value: ownReturns[key]! };
  }
  if (providerReturns && Object.prototype.hasOwnProperty.call(providerReturns, key)) {
    return { source: 'inherited', value: providerReturns[key]! };
  }
  return { source: 'inherited', value: bakedDefault };
}
